<mat-form-field [appearance]="appearance">
	<mat-label>{{ placeholder }}</mat-label>

	<mat-icon class="flash interactIcon left" (click)="removeOneTo(control)">remove</mat-icon>

	<input
		class="itemValue"
		matInput
		type="number"
		readonly
		[formControl]="control"
		[min]="min"
		[max]="max"
		[value]="activeValue != null ? activeValue : 0"
		[errorStateMatcher]="matcher"
	/>

	<mat-icon class="flash interactIcon border_right" (click)="addOneTo(control)">add</mat-icon>

	<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
	<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
		<mat-error *ngIf="control.hasError(key)">
			{{ control.getErrorMessage(key) }}
		</mat-error>
	</ng-template>
</mat-form-field>
